<div class="video-autoplay">
  @if (!videoLoaded()) {
    <img
      [src]="poster()"
      alt=""
      decoding="async"
      [attr.loading]="priority() ? 'eager' : 'lazy'"
      [attr.fetchpriority]="priority() ? 'high' : 'auto'"
    />
  }

  <video
    #videoRef
    loop
    playsinline
    autoplay
    muted
    [preload]="priority() ? 'auto' : 'metadata'"
    [poster]="poster()"
    [src]="src()"
    (playing)="setVideoLoaded()"
  ></video>

  <div class="video-autoplay__mask" [style.opacity]="maskOpacity()"></div>
</div>
